import styled from 'styled-components';

export const TopRated = styled.div`
background: #F2F2F2 0% 0% no-repeat padding-box;
border-radius: 15px;
padding: 20px;

`;
 

export const LogoWrapper = styled.div`
  width:160px;
  min-width:160px;
  height:120px;
  display: block;
  margin: 0 auto;
 img{
    width:100%;
 }
 

`;

export const AddressDetails = styled.div`
.btn-outline-success-blue{
    width: 100%;
    margin-top: 12px;
}


`;

export const AddressList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

`;
export const AddressItem = styled.li`
    color: #000000;
    font-size: 14px; 
    line-height: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 12px;
     width:100%;
     word-break: break-word;
         cursor: pointer;
    span{
        background: #FFFFFF 0% 0% no-repeat padding-box;  
        border-radius: 10px;
        width: 36px;
        height: 36px;
        min-width: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
a{
      color: #000;
    

}

`;

export const ShareSocialLink = styled.div`

`;


export const ShareList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 10px 0 0 0;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
`;
export const ShareItem = styled.li`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 10px;
    cursor:pointer;
   
    color: #000000;
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
    font-family: "Jost", sans-serif;
    display: flex;
    gap: 10px;
    align-items: center;
    width: calc(50% - 10px);
    &:nth-child(2){
        img{
            filter: invert(1);
        }
    }
    &:nth-child(3){
        width:100%;
       padding: 13px 12px;
    }
   a{
    display: inline-flex;
    gap: 10px;
    text-decoration: none;
    color: #000000;
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
    font-family: "Jost", sans-serif;
    padding: 0px;
    align-items: center;
   }
    &.donation-social-media-btn{
      padding:12px 15px;
    }
     
`;

